import { useRef, useEffect } from 'react';
import useMedia from 'use-media';

import intersect from '../utils/intersect';

function useIntersect(targetsSelector: string, callback: (item: HTMLElement, ...params: any) => void) {
  const observe = intersect(targetsSelector);
  const observeRef = useRef(observe);
  const isPortrait = useMedia({ orientation: 'portrait' });

  useEffect(() => {
    const unobserve = observeRef.current(callback);
    return () => unobserve && unobserve();
  }, [callback, observeRef, isPortrait]);
}

export default useIntersect;
